// functions to parse data to be displayed correctly in DropdownSelectComponent
import { AttributeValueType } from 'hooks/useGetAttributeValues';
import { BusinessType } from 'hooks/useGetBusinessesList';
import { TestUsersResponseType } from 'hooks/useGetTestUsers';
import {
  AttributeType,
  AudienceType,
  MessageTemplateType,
  OperatorType,
  TestUserType,
} from 'types/create-campaign';
import { StoreType } from 'types/storeTypes/stores-list';

var _ = require('lodash');

// List of businesses displayed in a dropdown.
export const parseDataBusiness = (
  businessesList: BusinessType[],
  onClickHandler: (id: number) => void
) => {
  let parsedBusinessList =
    businessesList.length > 0
      ? businessesList.map((item: BusinessType) => ({
          key: item.id?.toString(),
          label: item.name,
          value: item.id,
          onClick: () => onClickHandler(item.id!),
        }))
      : [];
  const sortedBusinessList = _.sortBy(parsedBusinessList, 'label');
  if (sortedBusinessList.length > 0) {
    sortedBusinessList.unshift({
      key: 'select-all',
      label: 'Show all businesses statistics',
      value: 0,
      onClick: () => onClickHandler(0),
    });
  }
  return sortedBusinessList;
};

// List of stores displayed in a dropdown.
// TODO: Remove this function after confirming that it is not needed anymore
export const parseDataStore_DEPRECATED = (
  storesList: StoreType[],
  onClickHandler: (item?: StoreType) => void
) => {
  let parsedDataStore =
    storesList.length > 0
      ? storesList.map((item: StoreType) => ({
          key: item.id!.toString(),
          label: item.name,
          value: item.id,
          onClick: () => onClickHandler(item),
        }))
      : [];

  const sortedDataStore = _.sortBy(parsedDataStore, 'label');
  if (sortedDataStore.length > 0) {
    sortedDataStore.unshift({
      key: 'select-all',
      label: 'Show all stores statistics',
      value: 0,
      onClick: () => onClickHandler(),
    });
  }
  return sortedDataStore;
};

// List of audiences displayed in a dropdown in create campaign flow.
export const parseDataAudience = (
  audiencesList: AudienceType[],
  onClickHandler: (item: AudienceType) => void
) => {
  return audiencesList.length > 0
    ? audiencesList.map((item: AudienceType) => ({
        key: item.id.toString(),
        label: item.name,
        onClick: () => onClickHandler(item),
      }))
    : [];
};

// List of stores in create campaign flow (multiselect dropdown)
export const parseMultiSelectDataStore = (
  storesList: StoreType[],
  onClickHandler: (item: StoreType) => void
) => {
  const parsedStoresList =
    storesList.length > 0
      ? storesList.map((item: StoreType) => ({
          key: item.id!.toString(),
          value: item.id!.toString(),
          label: item.name,
          onClick: () => onClickHandler(item),
        }))
      : [];
  const sortedStoresList = _.sortBy(parsedStoresList, 'label');
  return sortedStoresList;
};

// List of attributes in create campaign flow (select dropdown)
export const parseAttributesList = (
  attributesList: AttributeType[],
  onClickHandler: (item: AttributeType) => void
) => {
  return attributesList.length > 0
    ? attributesList.map((item: AttributeType) => ({
        key: item.name,
        value: item.name,
        label: `${item.display_name || item.name}`,
        attribute_type: item.attribute_type,
        onClick: () => onClickHandler(item),
      }))
    : [];
};

export const parseOperatorLabel = (operatorName: string) => {
  let transformedString = operatorName.replaceAll(/_/g, ' ');
  transformedString = transformedString.replaceAll('regex', '');
  return transformedString;
};

// List of attributes in create campaign flow (select dropdown)
export const parseOperatorsList = (
  operatorsList: OperatorType[],
  onClickHandler: (item: OperatorType) => void
) => {
  return operatorsList.length > 0
    ? operatorsList.map((item: OperatorType) => ({
        key: item,
        value: item,
        label: parseOperatorLabel(item),
        onClick: () => onClickHandler(item),
      }))
    : [];
};

// List of possible values for attribute_type === 'boolean'
export const parseBooleanValueList = (
  item: { value: boolean; ui_presentation: string }[],
  onClickHandler: (value: boolean) => void
) => {
  return item.length > 0
    ? item.map((item: { value: boolean; ui_presentation: string }) => ({
        key: item.ui_presentation,
        value: item.value,
        label: item.ui_presentation,
        onClick: () => onClickHandler(item.value),
      }))
    : [];
};

export const parseAttributeValuesList = (
  items: AttributeValueType[],
  onClickHandler: (item: AttributeValueType) => void
) => {
  return items.length > 0
    ? items.map((item: AttributeValueType) => ({
        label: item.ui_presentation || item.value,
        value: item.value,
        onClick: () => onClickHandler(item),
      }))
    : [];
};

// List of stores displayed in a dropdown.
export const parseMessagesTemplates = (
  messagesTemplates: MessageTemplateType[],
  onClickHandler: (item: MessageTemplateType) => void
) => {
  return messagesTemplates.length > 0
    ? [...messagesTemplates]
        .sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
        )
        .map((item: MessageTemplateType) => ({
          key: item.campaign_id + item.channel,
          label: item.name,
          onClick: () => onClickHandler(item),
        }))
    : [];
};

// List of test users for multiple dropdown
export const parseTestUsers = (
  testUsers: TestUserType[] | TestUsersResponseType
) => {
  return testUsers.length > 0
    ? testUsers.map((item: TestUserType) => ({
        key: item.id,
        label: item.nickname ? item.nickname : item.phone,
        value: item.id,
      }))
    : [];
};

// List of audience value searchable dropdown
export const parseAudienceValue = (value: string[]) => {
  return value.length > 0
    ? value.map((item: string) => ({
        key: item,
        label: item,
        value: item,
      }))
    : [];
};
